export type { EditTestamentaryEntitySectionOption } from './EditTestamentaryEntitySplitScreen.types';
export {
  EditTestamentaryEntitySection,
  getNextTestamentaryEntitySection,
  getPreviousTestamentaryEntitySection,
  getTestamentaryEntitySectionOptions,
  isEditTestamentaryEntitySection,
} from './EditTestamentaryEntitySplitScreen.types';
export type { EditTestamentaryEntitySplitScreenModalProps } from './EditTestamentaryEntitySplitScreenModal';
export { EditTestamentaryEntitySplitScreenModal } from './EditTestamentaryEntitySplitScreenModal';
